import Api from "../../Services/Api";
import { toastr } from "react-redux-toastr";

export const TENANATDATA = "riskwell/fetch/TENANATDATA";
export const TENANRDATAFAIL = "riskwell/fetch/TENANRDATAFAIL";
export const LOGGEDINLOADER = "riskwell/fetch/LOGGEDINLOADER";
export const TENANATSAERCHKEY = "riskwell/fetch/TENANATSEARCHKEY";

export const TenantData = (Data) => {
  return {
    type: TENANATDATA,
    payload: Data,
  };
};

export const TenantDataFail = (error) => {
  return {
    type: TENANRDATAFAIL,
    payload: error,
  };
};

export const loggedInLoader = (bool) => {
  return {
    type: LOGGEDINLOADER,
    payload: bool,
  };
};

export const TenantSearchKey = (Key) => {
  return {
    type: TENANATSAERCHKEY,
    payload: Key,
  };
};

export const FetchTenantData = () => async (dispatch) => {
  try {
    dispatch(loggedInLoader(true));
    let result = await Api.getTenantdata();
    dispatch(loggedInLoader(false));
    if (result.status === 200) {
      dispatch(TenantData(result.tenantResponse));
    } else {
      dispatch(loggedInLoader(false));
      dispatch(TenantData([]));
      toastr.error(result.statusText);
      dispatch(TenantDataFail(result.statusText));
    }
  } catch (error) {
    dispatch(loggedInLoader(false));
    toastr.error(error.message);
    //    dispatch(TenantFetchFail(error.message))
  }
};
